import { HypeIcon, useHeaderContext, useChatBotScript } from "@ob/core";
import { useMobileBreakpoint } from "@ob/theme";
import { Stack, Link } from "@mui/material";
import { FC, useContext } from "react";
import { Logo } from "../../assets";

export type HeaderProps = {
  onLogoClick?: () => void;
};

export const Header: FC<HeaderProps> = ({ onLogoClick }) => {
  const { isMobile } = useMobileBreakpoint();
  const { startChat } = useChatBotScript();
  const { backDisabled, hideBack, onBack } = useContext(useHeaderContext());
  return (
    <header className="layout--header">
      <nav
        aria-label="Navigazione principale"
        style={{
          display: "flex",
          flexDirection: "row",
          flex: 0,
          width: "100%",
          alignItems: "center",
          padding: "12px 16px",
        }}
      >
        <Stack flex="0 0 40px" alignItems="center">
          {isMobile && !backDisabled && !hideBack && (
            <Link
              variant="body"
              onClick={onBack}
              aria-label="Torna alla pagina precedente"
              role="button"
            >
              <HypeIcon
                name="icon_left_arrow"
                size={24}
                color="secondary.main"
                aria-hidden="true"
              />
            </Link>
          )}
        </Stack>
        <Stack flex={1} alignItems="center" justifyContent="center">
          {onLogoClick ? (
            <Link
              onClick={() => {
                if (onLogoClick) {
                  onLogoClick();
                }
              }}
              aria-label="Vai alla homepage di Lottomatica"
            >
              <Logo />
            </Link>
          ) : (
            <Logo />
          )}
        </Stack>
        <Stack flex="0 0 40px" alignItems="center">
          {isMobile && (
            <button
              onClick={startChat}
              aria-label="Apri chat di assistenza"
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 4,
              }}
            >
              <HypeIcon
                name="icon-chat"
                size={25}
                color="secondary.main"
                aria-hidden="true"
              />
            </button>
          )}
        </Stack>
      </nav>
    </header>
  );
};
